<div *ngIf="enviando">
  <app-loader></app-loader>
</div>

<lovers-popup
  [exibir]="exibePopupGenerico"
  (onClose)="exibePopupGenerico = false"
  tamanho="normal"
>
  <div class="popup__header">
    <p class="header__title">Formulário enviado!</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <p class="descricao__popup">
        Não se preocupe caso não entremos em contato imediato, os dados da sua
        empresa ficarão em nosso banco de parceiros. Feliz hoje!
      </p>
    </div>
    <div class="modal__buttons">
      <button type="button" class="button__home" (click)="irParaHome()">
        Ir para o Início
      </button>
      <button
        type="button"
        class="button__nova__parceria"
        (click)="novaParceria()"
      >
        Nova Parceria
      </button>
    </div>
  </div>
</lovers-popup>
<div class="form__cadastro">
  <div class="background">
    <img
      src="assets/images/backgrounds/background_gradiente_baixo.png"
      alt="Background gradiente"
      class="gradient__background_top"
    />
  </div>
  <div class="sent__register" *ngIf="!exibeCadastrado">
    <img
      src="assets/images/icons/sentRegister.svg"
      alt="Formulário enviado"
      class="sent__success"
    />
    <div class="sent__register__titulo">
      <p>Formulário enviado!</p>
    </div>
    <div class="sent__register__resumo">
      <p>
        Não se preocupe caso não entremos em contato imediato, os dados da sua
        empresa ficarão em nosso banco de parceiros. Feliz hoje!
      </p>
    </div>
    <div class="sent__buttons">
      <button
        type="button"
        class="button__home button__sent"
        (click)="irParaHome()"
      >
        Ir para o Início
      </button>
      <button
        type="button"
        class="button__nova__parceria button__sent"
        (click)="novaParceria()"
      >
        Nova Parceria
      </button>
    </div>
  </div>
  <form [formGroup]="cadastroParceiroForm" class="form" *ngIf="exibeCadastrado">
    <div class="form__cadastro__titulo">
      <p>Quer ser um Parceiro Lover?</p>
    </div>
    <div class="form__cadastro__resumo">
      <p>
        Para compartilhar momentos especiais com milhões de Cacau Lovers
        apaixonados por chocolate e experiências, basta preencher o formulário
        abaixo com todos os dados. Nosso time entrará em contato caso nossos
        corações estejam batendo na mesma frequência.
      </p>
    </div>
    <div class="cadastro__parceiro__container">
      <input
        id="nome"
        type="text"
        class="cadastro__parceiro__input"
        id="nome"
        formControlName="nome"
        placeholder=" "
        required
        [ngClass]="{
          'invalid-input':
            cadastroParceiroForm.get('nome').invalid &&
            cadastroParceiroForm.get('nome').errors &&
            (cadastroParceiroForm.get('nome').dirty ||
              cadastroParceiroForm.get('nome').touched ||
              this.formErro == true)
        }"
      />
      <label for="nome" class="cadastro__parceiro__label">
        Nome da sua empresa
      </label>
      <div
        class="invalid__container"
        *ngIf="
          cadastroParceiroForm.get('nome').invalid &&
          cadastroParceiroForm.get('nome').errors &&
          (cadastroParceiroForm.get('nome').dirty ||
            cadastroParceiroForm.get('nome').touched ||
            this.formErro == true)
        "
      >
        <small
          class="invalid-text"
          *ngIf="cadastroParceiroForm.get('nome').hasError('required')"
        >
          Esse campo é obrigatório!
        </small>
      </div>
    </div>
    <div class="cadastro__parceiro__container">
      <input
        type="text"
        class="cadastro__parceiro__input"
        id="cnpj"
        formControlName="cnpj"
        mask="00.000.000/0000-00"
        placeholder=" "
        required
        [ngClass]="{
          'invalid-input':
            cadastroParceiroForm.get('cnpj').invalid &&
            cadastroParceiroForm.get('cnpj').errors &&
            (cadastroParceiroForm.get('cnpj').dirty ||
              cadastroParceiroForm.get('cnpj').touched ||
              this.formErro == true)
        }"
      />
      <label for="cnpj" class="cadastro__parceiro__label"> Seu CNPJ </label>
      <div
        class="invalid__container"
        *ngIf="
          cadastroParceiroForm.get('cnpj').invalid &&
          cadastroParceiroForm.get('cnpj').errors &&
          (cadastroParceiroForm.get('cnpj').dirty ||
            cadastroParceiroForm.get('cnpj').touched ||
            this.formErro == true)
        "
      >
        <small
          class="invalid-text"
          *ngIf="cadastroParceiroForm.get('cnpj').hasError('required')"
        >
          Esse campo é obrigatório!
        </small>
      </div>
    </div>
    <div class="cadastro__parceiro__container">
      <select
        name="idTipoParceria"
        id="idTipoParceria"
        formControlName="idTipoParceria"
        class="cadastro__parceiro__input select__atividade"
        required
        [ngClass]="{
          'invalid-input':
            cadastroParceiroForm.get('idTipoParceria').invalid &&
            cadastroParceiroForm.get('idTipoParceria').errors &&
            (cadastroParceiroForm.get('idTipoParceria').dirty ||
              cadastroParceiroForm.get('idTipoParceria').touched ||
              this.formErro == true)
        }"
      >
        <option
          *ngFor="let tipoParceira of tiposParceira"
          [value]="tipoParceira.id"
        >
          {{ tipoParceira.descricao }}
        </option>
      </select>
      <label for="idTipoParceria" class="cadastro__parceiro__label">
        Qual o tipo de parceria?
      </label>
      <div
        class="invalid__container"
        *ngIf="
          cadastroParceiroForm.get('idTipoParceria').invalid &&
          cadastroParceiroForm.get('idTipoParceria').errors &&
          (cadastroParceiroForm.get('idTipoParceria').dirty ||
            cadastroParceiroForm.get('idTipoParceria').touched ||
            this.formErro == true)
        "
      >
        <small
          class="invalid-text cadastro__parceiro__label"
          *ngIf="
            cadastroParceiroForm.get('idTipoParceria').hasError('required')
          "
        >
          Esse campo é obrigatório!
        </small>
      </div>
    </div>
    <div class="cadastro__parceiro__container">
      <input
        type="text"
        class="cadastro__parceiro__input"
        id="urlSite"
        formControlName="urlSite"
        placeholder=" "
      />
      <label for="urlSite" class="cadastro__parceiro__label">
        Site da sua empresa
        <span class="optional__text"> (Opcional)</span></label
      >
    </div>

    <div class="cadastro__parceiro__container">
      <input
        type="text"
        class="cadastro__parceiro__input"
        id="redesSociais"
        formControlName="redesSociais"
        required
        placeholder=" "
        [ngClass]="{
          'invalid-input':
            cadastroParceiroForm.get('redesSociais').invalid &&
            cadastroParceiroForm.get('redesSociais').errors &&
            (cadastroParceiroForm.get('redesSociais').dirty ||
              cadastroParceiroForm.get('redesSociais').touched ||
              this.formErro == true)
        }"
      />
      <label for="redesSociais" class="cadastro__parceiro__label"
        >Instagram</label
      >
      <div
        class="invalid__container"
        *ngIf="
          cadastroParceiroForm.get('redesSociais').invalid &&
          cadastroParceiroForm.get('redesSociais').errors &&
          (cadastroParceiroForm.get('redesSociais').dirty ||
            cadastroParceiroForm.get('redesSociais').touched ||
            this.formErro == true)
        "
      >
        <small
          class="invalid-text"
          *ngIf="cadastroParceiroForm.get('redesSociais').hasError('required')"
        >
          Esse campo é obrigatório!
        </small>
      </div>
    </div>

    <div class="cadastro__parceiro__container">
      <input
        type="number"
        class="cadastro__parceiro__input"
        id="numeroSeguidores"
        (keypress)="ValidateNumber($event)"
        formControlName="numeroSeguidores"
        required
        placeholder=" "
        [ngClass]="{
          'invalid-input':
            cadastroParceiroForm.get('numeroSeguidores').invalid &&
            cadastroParceiroForm.get('numeroSeguidores').errors &&
            (cadastroParceiroForm.get('numeroSeguidores').dirty ||
              cadastroParceiroForm.get('numeroSeguidores').touched ||
              this.formErro == true)
        }"
      />
      <label for="numeroSeguidores" class="cadastro__parceiro__label"
        >Número de Seguidores no Instagram</label
      >
      <div
        class="invalid__container"
        *ngIf="
          cadastroParceiroForm.get('numeroSeguidores').invalid &&
          cadastroParceiroForm.get('numeroSeguidores').errors &&
          (cadastroParceiroForm.get('numeroSeguidores').dirty ||
            cadastroParceiroForm.get('numeroSeguidores').touched ||
            this.formErro == true)
        "
      >
        <small
          class="invalid-text"
          *ngIf="
            cadastroParceiroForm.get('numeroSeguidores').hasError('required')
          "
        >
          Esse campo é obrigatório!
        </small>
      </div>
    </div>

    <div class="cadastro__parceiro__container">
      <input
        type="text"
        class="cadastro__parceiro__input"
        placeholder=" "
        id="linkedIn"
        formControlName="linkedIn"
      />
      <label for="linkedIn" class="cadastro__parceiro__label">LinkedIn</label>
    </div>

    <div class="cadastro__parceiro__container">
      <input
        type="text"
        class="cadastro__parceiro__input"
        id="nomeContato"
        formControlName="nomeContato"
        required
        placeholder=" "
        [ngClass]="{
          'invalid-input':
            cadastroParceiroForm.get('nomeContato').invalid &&
            cadastroParceiroForm.get('nomeContato').errors &&
            (cadastroParceiroForm.get('nomeContato').dirty ||
              cadastroParceiroForm.get('nomeContato').touched ||
              this.formErro == true)
        }"
      />
      <label for="nomeContato" class="cadastro__parceiro__label"
        >Com quem vamos conversar</label
      >
      <div
        class="invalid__container"
        *ngIf="
          cadastroParceiroForm.get('nomeContato').invalid &&
          cadastroParceiroForm.get('nomeContato').errors &&
          (cadastroParceiroForm.get('nomeContato').dirty ||
            cadastroParceiroForm.get('nomeContato').touched ||
            this.formErro == true)
        "
      >
        <small
          class="invalid-text"
          *ngIf="cadastroParceiroForm.get('nomeContato').hasError('required')"
        >
          Esse campo é obrigatório!
        </small>
      </div>
    </div>

    <div class="cadastro__parceiro__container">
      <input
        type="text"
        class="cadastro__parceiro__input"
        id="telefoneContato"
        formControlName="telefoneContato"
        placeholder=" "
        mask="(00) 00000-0000"
        required
        [ngClass]="{
          'invalid-input':
            cadastroParceiroForm.get('telefoneContato').invalid &&
            cadastroParceiroForm.get('telefoneContato').errors &&
            (cadastroParceiroForm.get('telefoneContato').dirty ||
              cadastroParceiroForm.get('telefoneContato').touched ||
              this.formErro == true)
        }"
      />
      <label for="telefoneContato" class="cadastro__parceiro__label"
        >Seu telefone</label
      >
      <div
        class="invalid__container"
        *ngIf="
          cadastroParceiroForm.get('telefoneContato').invalid &&
          cadastroParceiroForm.get('telefoneContato').errors &&
          (cadastroParceiroForm.get('telefoneContato').dirty ||
            cadastroParceiroForm.get('telefoneContato').touched ||
            this.formErro == true)
        "
      >
        <small
          class="invalid-text"
          *ngIf="
            cadastroParceiroForm.get('telefoneContato').hasError('required')
          "
        >
          Esse campo é obrigatório!
        </small>
      </div>
    </div>
    <div class="cadastro__parceiro__container">
      <input
        type="text"
        class="cadastro__parceiro__input"
        id="emailContato"
        formControlName="emailContato"
        required
        placeholder=" "
        [ngClass]="{
          'invalid-input':
            cadastroParceiroForm.get('emailContato').invalid &&
            cadastroParceiroForm.get('emailContato').errors &&
            (cadastroParceiroForm.get('emailContato').dirty ||
              cadastroParceiroForm.get('emailContato').touched ||
              this.formErro == true)
        }"
      />
      <label for="emailContato" class="cadastro__parceiro__label"
        >Seu e-mail</label
      >
      <div
        class="invalid__container"
        *ngIf="
          cadastroParceiroForm.get('emailContato').invalid &&
          cadastroParceiroForm.get('emailContato').errors &&
          (cadastroParceiroForm.get('emailContato').dirty ||
            cadastroParceiroForm.get('emailContato').touched ||
            this.formErro == true)
        "
      >
        <small
          class="invalid-text"
          *ngIf="cadastroParceiroForm.get('emailContato').hasError('required')"
        >
          Esse campo é obrigatório!
        </small>
      </div>
    </div>
    <div
      class="cadastro__parceiro__container cadastro__parceiro__container_area"
    >
      <label for="obervacoes" class="cadastro__parceiro__label label__textarea"
        >Você quer nos dizer algo mais?</label
      >
      <textarea
        type="text"
        class="cadastro__parceiro__input cadastro__parceiro__textarea"
        id="obervacoes"
        formControlName="obervacoes"
        oninput=""
        [ngClass]="{
          'invalid-input':
            cadastroParceiroForm.get('emailContato').invalid &&
            cadastroParceiroForm.get('emailContato').errors &&
            (cadastroParceiroForm.get('emailContato').dirty ||
              cadastroParceiroForm.get('emailContato').touched ||
              this.formErro == true)
        }"
      ></textarea>
      <div
        class="invalid__container_text_area"
        *ngIf="
          cadastroParceiroForm.get('obervacoes').invalid &&
          cadastroParceiroForm.get('obervacoes').errors &&
          (cadastroParceiroForm.get('obervacoes').dirty ||
            cadastroParceiroForm.get('obervacoes').touched ||
            this.formErro == true)
        "
      >
        <!-- <small
          class="invalid-text"
          *ngIf="cadastroParceiroForm.get('obervacoes').hasError('required')"
        >
          Esse campo é obrigatório!
        </small> -->
      </div>
    </div>
    <button
      id="enviar"
      type="submit"
      class="button__nova__parceria button__enviar"
      [disabled]="enviando"
      (click)="abrirPopupEnvioFormulario()"
    >
      Enviar
    </button>
  </form>
  <div class="background">
    <img
      src="assets/images/backgrounds/background_gradiente_cima.png"
      alt="Background gradiente"
      class="gradient__background__bottom"
    />
  </div>
</div>

<lovers-popup
  [exibir]="exibirModalConfirmarEnvioFormulario"
  (onClose)="exibirModalConfirmarEnvioFormulario = false"
  tamanho="pequeno"
>
  <div class="popup__header">
    <p class="header__title"></p>
  </div>
  <br />
  <div class="popup__body">
    <div class="div__mensagem">{{ mensagem }}</div>
  </div>
  <div class="popup__footer">
    <div class="footer__content d-flex justify-content-center">
      <button
        class="lovers-button mr-4"
        style="background-color: #ff9999"
        (click)="fecharPopupEnvioFormulario()"
      >
        Cancelar
      </button>
      <button id="enviar" class="lovers-button" (click)="controlePopupCadastro(true)">
        Enviar
      </button>
    </div>
  </div>
</lovers-popup>
